import {
  PROTOCOL_MANIFEST_METADATA,
  protocolBrandPath,
  protocolManifestPath,
  publicProtocolManifest,
} from '@hub/common';
import {
  getStorage,
  ref,
  uploadBytesResumable,
  uploadString,
  getDownloadURL,
} from 'firebase/storage';
import type { BrandFile, DbProtocolManifest } from '@hub/common';

export const uploadBlobToStorage = (
  path: string,
  blob: Blob
): Promise<string> => {
  const storage = getStorage();
  const storageRef = ref(storage, path);

  const metadata = {
    contentType: blob.type,
    cacheControl: 'public,max-age=31536000,immutable',
  };

  const uploadTask = uploadBytesResumable(storageRef, blob, metadata);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      'state_changed',
      snapshot => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${progress.toFixed(1)} % done`);
      },
      reject,
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        console.log(`${path} uploaded to ${url}`);
        resolve(url);
      }
    );
  });
};

export const uploadFileToStorage = (
  path: string,
  type: 'definition' | 'translation' | 'style',
  content: string
): Promise<string> => {
  console.log('uploadFileToStorage');

  const mimeTypes = {
    translation: 'application/json',
    definition: 'text/plain',
    style: 'text/css',
  };

  return uploadBlobToStorage(
    path,
    new Blob([content], { type: mimeTypes[type] })
  );
};

/** Uploads the protocol's brand copy: its brand file, or JSON `null`. */
export const uploadProtocolBrand = (
  protocolId: string,
  file: BrandFile | null
): Promise<string> =>
  uploadBlobToStorage(
    protocolBrandPath(protocolId),
    new Blob([JSON.stringify(file)], { type: 'application/json' })
  );

/** Uploads the public copy of the protocol's manifest. */
export const uploadProtocolManifest = async (
  protocolId: string,
  manifest: DbProtocolManifest
): Promise<void> => {
  await uploadString(
    ref(getStorage(), protocolManifestPath(protocolId)),
    JSON.stringify(publicProtocolManifest(manifest)),
    'raw',
    PROTOCOL_MANIFEST_METADATA
  );
};
